var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4133 4.5H3.58796L4.46796 15L12.5333 15L13.4133 4.5ZM3.58796 3.5C3.00273 3.5 2.54258 4.00033 2.59145 4.58352L3.47145 15.0835C3.51488 15.6016 3.94805 16 4.46796 16H12.5333C13.0532 16 13.4864 15.6016 13.5298 15.0835L14.4098 4.58352C14.4587 4.00033 13.9986 3.5 13.4133 3.5H3.58796Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 2.5H2.5V3.5H14.5V2.5ZM2.5 1.5C1.94772 1.5 1.5 1.94772 1.5 2.5V3.5C1.5 4.05228 1.94772 4.5 2.5 4.5H14.5C15.0523 4.5 15.5 4.05228 15.5 3.5V2.5C15.5 1.94772 15.0523 1.5 14.5 1.5H2.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5 1C6.5 0.447715 6.94772 0 7.5 0L9.5 0C10.0523 0 10.5 0.447715 10.5 1V1.5H6.5V1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.435c7a8fa1afab3b287c51e6f7c056a6.svg";
export { ForwardRef as ReactComponent };